<template>
  <div>
    <UIBlocker :isShow="isSaving">
      Atualizando Dados. Aguarde...
    </UIBlocker>
    <b-modal
      :title="acao == 'alterar' ? 'Alterar Medição' : 'Nova Medição'"
      id="modal-medicao"
      no-close-on-backdrop
      no-close-on-esc
      no-fade
      size="lg"
    >
      <b-form-row>
        <b-col>
          <b-form-group label="Data da Medição" label-size="sm" label-for="dt_medicao">
            <date-picker
              input-class="form-control form-control-sm"
              :clearable="false"
              maxlength="10"
              format="DD/MM/YYYY"
              value-type="YYYY-MM-DD"
              id="dt_medicao"
              :disabled="acao != 'incluir'"
              v-model="registro.dt_medicao"
            ></date-picker>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group label="Valor da Medição R$" label-size="sm" label-for="vl_medicao">
            <b-form-input
              size="sm"
              maxlength="20"
              id="vl_medicao"
              v-model="registro.vl_medicao"
              trim
              v-mask="{
                alias: 'numeric',
                autoUnmask: true,
                greedy: true,
                radixPoint: ',',
                groupSeparator: '.',
                digits: 2,
                digitsOptional: false,
                autoGroup: true,
                allowPlus: false,
                allowMinus: false,
                onUnMask: function(maskedValue) {
                  var x = maskedValue.split(',');
                  return x[0].replace(/\./g, '') + '.' + x[1];
                },
              }"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Cotação R$" label-size="sm" label-for="cotacao">
            <b-form-input
              size="sm"
              maxlength="20"
              id="cotacao"
              v-model="registro.cotacao"
              trim
              v-mask="{
                alias: 'numeric',
                autoUnmask: true,
                greedy: true,
                radixPoint: ',',
                groupSeparator: '.',
                digits: 4,
                digitsOptional: false,
                autoGroup: true,
                allowPlus: false,
                allowMinus: false,
                onUnMask: function(maskedValue) {
                  var x = maskedValue.split(',');
                  return x[0].replace(/\./g, '') + '.' + x[1];
                },
              }"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Valor 2ª Moeda" label-size="sm" label-for="vl_medicao_m2">
            <b-form-input
              size="sm"
              maxlength="20"
              id="vl_medicao_m2"
              v-model="VlMedicaoM2"
              trim
              disabled
              v-mask="{
                alias: 'numeric',
                autoUnmask: true,
                greedy: true,
                radixPoint: ',',
                groupSeparator: '.',
                digits: 2,
                digitsOptional: false,
                autoGroup: true,
                allowPlus: false,
                allowMinus: false,
                onUnMask: function(maskedValue) {
                  var x = maskedValue.split(',');
                  return x[0].replace(/\./g, '') + '.' + x[1];
                },
              }"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row class="mt-2">
        <b-col>
          <b-form-group label-size="sm" label="Observações">
            <b-form-textarea
              size="sm"
              no-resize
              v-model="registro.observacoes"
              rows="10"
              maxlength="65535"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-form-row>
      <template v-slot:modal-footer>
        <b-button size="sm" @click="doSaveMedicao()" variant="primary"> <i class="fas fa-check"></i> Gravar </b-button>
        <b-button size="sm" @click="() => $bvModal.hide('modal-medicao')">Fechar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import { baseApiUrl, validateDate } from "@/global";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";

import { bidbus } from "@/main";
import { formatMoney } from "../../../global";
import UIBlocker from "../../layout/UIBlocker.vue";

export default {
  name: "ModalMedicao",
  components: { DatePicker, UIBlocker },
  computed: {
    VlMedicaoM2: {
      get() {
        let _vlmedicao = parseFloat(this.registro.vl_medicao || 0);
        let _cotacao = parseFloat(this.registro.cotacao || 0);
        return formatMoney(_vlmedicao * _cotacao, 2, "", ".", ",");
      },
    },
  },
  props: {
    registro: { type: Object, required: true },
    acao: { type: String, required: true },
  },
  data: function() {
    return {
      isSaving: false,
    };
  },
  methods: {
    doSaveMedicao() {
      if (!validateDate(this.registro.dt_medicao, "YYYY-MM-DD")) {
        this.$toasted.global.warning({
          msg: "Data da Medição Inválida!",
        });
      }
      this.isSaving = true;
      let _saveObj = { ...this.registro };
      _saveObj.dt_medicao = this.registro.dt_medicao;
      _saveObj.vl_medicao = parseFloat(this.registro.vl_medicao);
      _saveObj.cotacao = parseFloat(this.registro.cotacao);

      if (this.acao == "incluir") {
        axios
          .post(`${baseApiUrl}/bid/medicoes`, _saveObj)
          .then(() => {
            this.$emit("updateMedicao");
            bidbus.$emit("refreshResumo");
            this.$bvModal.hide("modal-medicao");
          })
          .then(() => (this.isSaving = false));
      } else {
        axios.put(`${baseApiUrl}/bid/medicoes/${this.registro.medicao_id}`, _saveObj).then(() => {
          this.isSaving = false;
          this.$emit("updateMedicao");
          bidbus.$emit("refreshResumo");
          this.$bvModal.hide("modal-medicao");
        });
      }
    },
  },
};
</script>

<style></style>
